// Вспомогательные функции и значения для работы с e-mail адресами.
export class EmailAddressHelper {

    static emailAddressAllowedCharsRegexp: RegExp = /[a-zA-Z0-9@._%+-]/
    static emailNameCleaningRegexp: RegExp = /[^a-zA-Z0-9._%+-]/g
    static emailDomainCleaningRegexp: RegExp = /[^a-zA-Z0-9._%+-]/g
    static emailDomainValidationRegexp: RegExp = /^[a-zA-Z0-9.-]+\.[a-z]{2,}$/i
    static minEmailNameForSuggestions: number = 5

    // Удаление лишних символов из e-mail адреса.
    static cleanEmailAddress(email: string): string {
        const parts = email.trim().split('@')
        let ret = parts[0].replace(this.emailNameCleaningRegexp, '').replace(/[._-]$/, '')
        if (parts.length > 1) {
            ret += '@' + this.cleanEmailDomain(parts[1])
        }
        return ret
    }

    // Удаление лишних символов из домена e-mail адреса.
    static cleanEmailDomain(domain: string): string {
        return domain.replace(this.emailDomainCleaningRegexp, '').replace(/\s+/, '')
    }

    // Проверка e-mail адреса на содержание недопустимых символов.
    static hasInvalidSymbolsInEmailAddress(email: string): boolean {
        const parts = email.trim().split('@')
        if (parts.length !== 2) {
            return false
        }
        return (
            this.emailNameCleaningRegexp.test(parts[0])
            || this.emailDomainCleaningRegexp.test(parts[1])
        )
    }

    // Проверка e-mail адреса на корректность.
    static isValidEmailAddress(email: string): boolean {
        if (this.hasInvalidSymbolsInEmailAddress(email)) {
            return false
        }
        const parts = email.trim().split('@')
        return this.emailDomainValidationRegexp.test(this.cleanEmailDomain(parts[1] ?? ''))
    }

    // Получение части email адреса до @ для подсказок в поле ввода e-mail адреса.
    static getEmailNameForSuggestions(email: string): string {
        const parts = email.trim().split('@')
        // Скрываем подсказки доменов, если длина имени слишком короткая
        // и если еще нет домена или '@' в email.
        if (
            parts.length === 1
            && parts[0].length < this.minEmailNameForSuggestions
        ) {
            return ''
        }
        return parts[0]
    }
}
